<template>
	<ons-toolbar>
		<div class="center has-logo">
			<img class="toolbar-logo" :src="defaultLogo">
		</div>
		<div class="right">
			<v-ons-toolbar-button @click="openMainMenu" modifier="white-content" slot="right">
				<v-ons-icon icon="ion-navicon, material:md-menu"></v-ons-icon>
			</v-ons-toolbar-button>
		</div>
	</ons-toolbar>
</template>

<script>
	export default {
		name: "StandardToolbar",
		methods: {
			openMainMenu() {
				this.$store.commit('splitter/toggle');
			}
		},
		computed: {
			defaultLogo() {
				return process.env.VUE_APP_VARIANT + `/img/logo.svg`
			}
		}
	}
</script>

<style scoped>

</style>